export const formContent = {
    heading: 'Log in to Elite Partyz',
    userType: {
        id: 'userType',
        label: 'User type',
        options: [
            { value: 'buyer', label: 'Member' },
            { value: 'supplier', label: 'Business' }
        ],
        validation: {
            required: "Select user type"
        }
    },
    emailAddress: {
        id: 'emailAddress',
        label: 'Email',
        validation: {
            required: "Email is required"
        }
    },
    password: {
        id: 'password',
        type: 'password',
        label: 'Password',
        validation: {
            required: "Password is required"
        }
    },
    loginButton: {
        id: 'loginButton',
        label: 'Login',
        type: 'submit'
    },
    forgotPasswordLink: {
        id: 'forgotPasswordLink',
        label: 'Forgot Password?',
        href: '/forgot-password'
    },
    signupButton: {
        id: 'signupButton',
        label: 'Sign Up',
        type: 'button',
        href: '/register',
        variant: 'button-dark'
    }
}
